
import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HelpSearch } from './components/SearchBox';
import { VersionSelector } from './components/VersionSelector';
import { useStyles } from './styles';
import { darkTheme, lightTheme } from './themes/theme';

interface HomeProps {
    apiVersion: string;
    versions: string[];
    darkMode: boolean;
    handleDarkModeChange: () => void;
    handleVersionChange: (version: string) => void;    
}
const Home: React.FC<HomeProps> = ({apiVersion, handleVersionChange, darkMode, handleDarkModeChange, versions}) => {
    const classes = useStyles();

    const theme = darkMode ? darkTheme : lightTheme;
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={classes.root} flexDirection={'column'} minHeight="100vh">
                {/* Header Section */}
                <AppBar sx={classes.appBar}>
                    <Toolbar sx={classes.root}>
                        <Link href="/" sx={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                src="/revit.svg"
                                alt="Revit API 中英文对照"
                                style={{ height: '40px', cursor: 'pointer' }}
                            />
                        </Link>
                        {
                            versions.map((version, index) => (
                                <Link
                                    href={`/${version}`}
                                    key={index}
                                    sx={{
                                        color: 'white',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: 'lightgray',
                                        },
                                        margin:1,
                                    }}
                                    onClick={() => handleVersionChange(version)}
                                >
                                    {version}
                                </Link>
                            ))
                        }   
                        <Box sx={{ marginLeft: 'auto' }}>
                            <IconButton color="inherit" onClick={handleDarkModeChange}>
                                {darkMode ? <DarkMode /> : <LightMode />}
                            </IconButton>  
                        </Box>                   
                    </Toolbar>
                </AppBar>

                {/* Content */}
                <Box 
                    sx={{
                        flexGrow: 1,
                        p: 2,
                        maxWidth: 'md',
                        mx: 'auto',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 4,
                    }}
                >
                    {/* Image Section */}
                    <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            mt: 9,
                            mb: 2,
                        }}>
                        <img src="/banner.jpg" alt="Revit API"                             
                            style={{
                                width: '100%',
                                maxWidth: '600px',
                                objectFit: 'cover',
                                borderRadius: '20px', // 圆角
                                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)', // 添加阴影
                                transition: 'all 0.3s ease-in-out', // 平滑过渡
                            }}/>
                    </Box>
                    {/* Search Section */}
                    <Box display={'flex'}>
                        <Box sx={{ flex: 1}}> 
                            <HelpSearch apiVersion={apiVersion} maxResults={20}/>
                        </Box>
                        <Box sx={{ marginLeft: 0}}>
                            <VersionSelector
                                apiVersion= {apiVersion}
                                changeVersion={handleVersionChange}
                                versions={versions}
                            />                      
                        </Box>
                    </Box>

                </Box>
            </Box>
            <Helmet>
                {versions.map((version, index) => (
                    <meta key={index} name={`Revit API-${version}`} content={version} />
                ))}
            </Helmet>
        </ThemeProvider>
    );
};

export default Home;